import {
  CompetitionFormat,
  RankingMethod,
} from '@api/competitionsApi/interfaces';

export type CompetitionRankingRulesInput = {
  rankingMethod: RankingMethod;
  minCountingScores: number;
  rankingBestN?: number | null;
  format?: CompetitionFormat;
};

export const canShowCompetitionRankingRulesSummary = (
  input: Partial<CompetitionRankingRulesInput>
): input is CompetitionRankingRulesInput => {
  if (!input.rankingMethod) {
    return false;
  }

  if (
    input.minCountingScores === undefined ||
    Number(input.minCountingScores) < 1
  ) {
    return false;
  }

  if (input.rankingMethod === 'best_n_average') {
    return (
      input.rankingBestN !== undefined &&
      input.rankingBestN !== null &&
      Number(input.rankingBestN) >= 1
    );
  }

  return true;
};

export type CompetitionRankingRulesAudience = 'portal' | 'manage';

export const getCompetitionRankingQualificationTranslationKey = (
  format: CompetitionFormat = 'self_paced',
  audience: CompetitionRankingRulesAudience = 'portal'
): string => {
  return `competitions:rankingRules.qualification.${audience}.${format}`;
};

export const getCompetitionRankingMethodTranslationKey = (
  rankingMethod: RankingMethod,
  audience: CompetitionRankingRulesAudience = 'portal'
): string => {
  return `competitions:rankingRules.method.${audience}.${rankingMethod}`;
};
